class ShortFullText {
    constructor(el) {
        this.shortText = el.querySelector('.short-text');
        this.fullText = el.querySelector('.full-text');
        this.link = el.querySelector('.link');

        this.initEvents();
    }

    initEvents() {
        if (this.link)
        {
            this.link.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleText();
            });
        }
    }

    toggleText() {
        if (this.shortText.classList.contains('hidden')) {
            this.shortText.classList.remove('hidden');
            this.fullText.classList.add('hidden');
            this.link.innerHTML = 'Read more';
        } else {
            this.shortText.classList.add('hidden');
            this.fullText.classList.remove('hidden');
            this.link.innerHTML = 'Read less';
        }
    }
}

export default ShortFullText;